<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
</script>

<template>
  <div class="min-h-screen min-w-full bg-[#f3f4f5]">
    <slot />
  </div>
</template>
